import { Button, Input, Select, TableProps } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import TitleBar from "../../../../components/common/TitleBar";
import CustomTable from "../../../../components/ui/CustomTable";
import { TSurveyTemplate } from "../../../../features/organization/survey/survey.type";
import { useGetSurveyDataQuery } from "../../../../features/organization/survey/surveyApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize, valueOrNa } from "../../../../utils/string";
import { addKeyInArray, selectSearchOption } from "../../../../utils/utils";
import { statusList } from "./_data/data";

const STATUS_CONFIG = {
  active: "status status-success",
  inactive: "status status-danger",
};
export default function SurveyDataList() {
  const businessId = useAppSelector((state) => state.auth.user?.business_id);

  const {
    page,
    limit,
    filter,
    handleFilter,
    handleLimit,
    handlePagination,
    handleSearch,
    keyword,
  } = useTable<{ status: string }>();

  const { data, isError, isLoading, isFetching, error } = useGetSurveyDataQuery(
    {
      params: {
        business_id: businessId as number,
        ...filter,
        search: keyword,
      },
    },
    { skip: !businessId }
  );

  const surveyData = data?.data?.templates;

  useError(isError, error, "Survey data get fail");

  const columns: TableProps<TSurveyTemplate>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Template Name",
      dataIndex: "title",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Created at",
      align: "center",
      dataIndex: "created_at",
      render: (val) => valueOrNa(formatDate(val)),
    },
    {
      title: "Total Question",
      align: "center",
      dataIndex: "surveyQuestion",
      render: (val) => valueOrNa(val?.length),
    },
    {
      title: "Total Response",
      align: "center",
      dataIndex: "response_count",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (val) => {
        return (
          <span className={STATUS_CONFIG?.[val as keyof typeof STATUS_CONFIG]}>
            {valueOrNa(capitalize(val))}
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      width: 130,
      render: (val) => (
        <Link to={`/organizations/survey/templates/survey-data-details/${val}`}>
          <Button
            size="small"
            className="w-full !bg-[#fbf4ff] !text-primary !border-transparent hover:!border-primary"
          >
            Details
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Survey">
        <TitleBar title="Survey Data" />

        <CustomTable
          loading={isLoading || isFetching}
          limit={limit}
          // limit={data?.data?.total}
          page={page}
          columns={columns}
          total={data?.data?.total}
          dataSource={addKeyInArray(surveyData)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ minWidth: 170, maxWidth: 180 }}
                onChange={(val) => handleSearch(val)}
              />

              <Select
                allowClear
                showSearch
                placeholder="Status"
                filterOption={selectSearchOption}
                options={statusList}
                className="min-w-[90px]"
                suffixIcon={<SelectDownIcon />}
                rootClassName="icon-gray"
                value={filter.status}
                onChange={(val) => handleFilter("status", val)}
                popupMatchSelectWidth={120}
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
